import {Component, Input, OnInit} from '@angular/core';
import {ControlContainer, FormControl, FormGroup, NgForm} from '@angular/forms';
import {AutoDestroy} from '@ox/utils';
import {FormFunctionService} from '@ox/utils';
import {States} from '@ox/typings';
import {Subject, take, takeUntil} from 'rxjs';

@Component({
  selector: 'ox-state-input',
  templateUrl: './state-input.component.html',
  styleUrls: ['./state-input.component.scss'],
  viewProviders: [{provide: ControlContainer, useExisting: NgForm}]
})
export class StateInputComponent implements OnInit {
  @AutoDestroy destroy$: Subject<void> = new Subject<void>();
  @Input() webu = true;
  @Input() placeHolderText: string;
  @Input() stateCode: string;
  @Input() validationType: string;
  @Input() widgetSize: boolean;
  @Input() isAriaRequired: boolean;
  @Input() label: string;
  @Input() inputElClasses: string;

  // Take in the parent formGroup to get form control
  @Input() formGroupInput: FormGroup;
  @Input() formControlNameInput: string;

  public stateLabel: string | null;
  public invalidStateCode = false;
  public lostFocus = false;
  public statesObj: States;
  
  get control() {  
    return this.formGroupInput.controls[this.formControlNameInput] as FormControl; 
  }

  constructor(
    private formFunctionService: FormFunctionService
  ) {
    
  }
  
  public onFocus() {
    this.lostFocus = false;
  }

  ngOnInit(): void {
    this.getStatesObj();

    if (this.control) {
      this.control.valueChanges.pipe(
        takeUntil(this.destroy$))
        .subscribe(value => {
        this.checkStateCode(value);
      });
    }
  }

  public showError() {
    const touched = this.control ? this.control.touched : false;
    return touched && this.invalidStateCode;
  }

  public getStatesObj() {
    this.formFunctionService.getStates().pipe(
      take(1)
    ).subscribe(statesLov => {
      this.statesObj = statesLov;
    });
  }

  private checkStateCode(value: string) {
    const stateCode = value ? value.toUpperCase() : value;

    this.invalidStateCode = !stateCode || !(this.statesObj && this.statesObj[stateCode]);
    this.stateLabel = this.invalidStateCode ? null : this.statesObj[stateCode];

    if (!stateCode && this.control.errors && this.control.errors['required']) {
      this.invalidStateCode = false;
    }

    this.formGroupInput.setErrors(this.invalidStateCode ? {invalid: true} : null);
  }
}
